import styled from "styled-components";

export const EmptyContainer = styled.div`
  .no-result-image {
    height: 200px;
    width: 350px;
  }
  .no-result-msg {
    color: #070708;
    font-size: 24px;
    font-weight: 500;
    line-height: 28px;
  }
`;
